import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ClientSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="32429" id="client-reviews" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] max-w-[800px] opacity-[0.05] select-none">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/logo_watermark.png" alt="" className="w-full h-auto grayscale" />
        </div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_85%)]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          

          <div className="max-w-5xl mx-auto">
            
          </div>
        </div>
      </div>
    </section>;
}